import { render } from "./DialogAlreadyReserved.vue?vue&type=template&id=22477d81"
import script from "./DialogAlreadyReserved.vue?vue&type=script&lang=js"
export * from "./DialogAlreadyReserved.vue?vue&type=script&lang=js"
script.render = render

export default script